import React, { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { Label, Loader } from "@/components/common";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { AccountsTab, RulesTab, SettingsTab, BackfillTab } from "@/components/accounting/AccTabs";

export default function Comptabilite() {
  const [meta, setMeta] = useState(null);
  const load = useCallback(() => api.get("/accounting/meta").then((r) => setMeta(r.data)), []);
  useEffect(() => { load(); }, [load]);
  if (!meta) return <Loader />;
  return (
    <div className="space-y-6" data-testid="comptabilite-page">
      <div><Label>Finances</Label><h1 className="font-display text-3xl font-semibold tracking-tight sm:text-4xl">Pré-comptabilité</h1>
        <p className="mt-1 text-sm text-gray-500">Plan comptable, règles de classement, paramètres et reprise des factures. Les propositions automatiques sont toujours validées par vous.</p></div>
      <Tabs defaultValue="accounts">
        <TabsList className="flex h-auto flex-wrap rounded-full">
          <TabsTrigger value="accounts" data-testid="tab-accounts" className="rounded-full">Plan comptable</TabsTrigger>
          <TabsTrigger value="rules" data-testid="tab-rules" className="rounded-full">Règles</TabsTrigger>
          <TabsTrigger value="settings" data-testid="tab-settings" className="rounded-full">Paramètres</TabsTrigger>
          <TabsTrigger value="backfill" data-testid="tab-backfill" className="rounded-full">Reprise historique</TabsTrigger>
        </TabsList>
        <TabsContent value="accounts" className="mt-4"><AccountsTab meta={meta} reload={load} /></TabsContent>
        <TabsContent value="rules" className="mt-4"><RulesTab meta={meta} /></TabsContent>
        <TabsContent value="settings" className="mt-4"><SettingsTab meta={meta} reload={load} /></TabsContent>
        <TabsContent value="backfill" className="mt-4"><BackfillTab /></TabsContent>
      </Tabs>
    </div>
  );
}
